import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import _ from 'lodash';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
// import '../resource/css/centerlogin.css';
import ReactApexChart from 'react-apexcharts';
import qs from 'query-string';
import config from '../../config';

// TODO
// add some custom css to fix scroll bar
class TestingPopChartV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            error:false,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'line',
                    stacked: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        startingShape: 'flat',
                        endingShape: 'flat',
                        columnWidth: '25%',
                        barHeight: '70%',
                        distributed: false,
                        rangeBarOverlap: true,
                        colors: {
                            ranges: [{
                                from: 0,
                                to: 0,
                                color: undefined
                            }],
                            backgroundBarColors: [],
                            backgroundBarOpacity: 1,
                            backgroundBarRadius: 0,
                        },
                        
                    },
                },
                dataLabels: {
                    enabled: false
                },
                colors: ['#0084a8b3', '#7da19d','#055a87'],
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'butt',
                    // colors: ['#5c5c5c'],
                    width: 2,
                    dashArray: 0,      
                },
                fill: {
                    type: "solid",
                    opacity:1,
                    
                },
                
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM dd',
                            day: 'MMM dd',
                        }
                    }
                },
                yaxis: [
                    
                    {
                        seriesName: 'Population Tested %',
                        opposite: false,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#5c5c5c'
                        },
                        fill:{
                            opacity:0.1
                        },
                        labels: {
                            style: {
                                colors: '#5c5c5c',
                                fontSize: '11px'
                            },
                            formatter: function(value, timestamp, index) {
                                return value.toFixed(0)+"%";
                            }
                            
                        },
                        title: {
                            text: "Population Tested %",
                            // style: {
                            //     color: '#ffc838',
                            // }
                        }
                    },
                    {
                        seriesName: 'Daily Tests',
                        opposite: true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#0084a8b3'
                        },
                        labels: {
                            style: {
                                colors: '#0084a8b3',
                                fontSize: '11px'
                            },
                            formatter: function(value, timestamp, index) {
                                return value.toFixed(0);
                            }
                        },
                        title: {
                            text: "Daily Tests",
                            // style: {
                            //     color: '#0084a8b3',
                            // }
                        },
                        tooltip: {
                            enabled: true
                        }
                    },
                    {
                        seriesName: 'Range',
                        show:false,
                        opposite: true,
                        axisTicks: {
                            show: true,
                        },
                        axisBorder: {
                            show: true,
                            color: '#5c5c5c'
                        },
                        // fill:{
                        //     opacity:0.1
                        // },
                        labels: {
                            style: {
                                colors: '#5c5c5c',
                                fontSize: '11px'
                            },
                            formatter: function(value, timestamp, index) {
                                return value.toFixed(0)+"%";
                            }
                            
                        },
                        title: {
                            text: "Positivity Rate",
                            // style: {
                            //     color: '#ffc838',
                            // }
                        }
                    },
                    // {
                    //     seriesName: 'Range',
                    //     show:false,
                    //     opposite: true,
                    //     axisTicks: {
                    //         show: true,
                    //     },
                    //     axisBorder: {
                    //         show: true,
                    //         color: '#5c5c5c'
                    //     },
                        
                    //     labels: {
                    //         style: {
                    //             colors: '#5c5c5c',
                    //             fontSize: '11px'
                    //         },
                    //         formatter: function(value, timestamp, index) {
                    //             return value.toFixed(0)+"%";
                    //         }
                            
                    //     },
                    //     title: {
                    //         text: "Positivity Rate",
                    //         // style: {
                    //         //     color: '#ffc838',
                    //         // }
                    //     }
                    // }
                ],
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: true,
                    fillSeriesColor: false,
                    // theme: true,
                    style: {
                      fontSize: '11px',
                      //fontFamily: undefined
                    },
                    onDatasetHover: {
                        highlightDataSeries: false,
                    },
                    
                    y: [
                    
                    {
                        formatter: function(value, timestamp, index) {
                            return value.toFixed(2)+"%";
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                    {
                        formatter: function(value, timestamp, index) {
                            return value.toFixed(0);
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                    {
                        formatter: function(value, timestamp, index) {
                            return value.toFixed(0);
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                    ],
                    
                    marker: {
                        show: true,
                    },
                },
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      };
    }

    async loadOut(){
        const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let cleanDate=[];
        let cleanTotalTests=[];
        let cleanTestPercent=[];
        let dailyMove=[];
        let positiveMove=[];
        let qWhere="testsDaily IS NOT NULL";
        let fieldMap;
        let url;
        let qMap={
            Day3:{
                daily:{
                    field:"testsDaily3DayMovingAvg",
                    text:"Daily Tests - 3 Day Avg"
                },
                positive:{
                    field:"testspercentpositive3DayMovingAvg",
                    text:"Positivity Rate - 3 Day Avg"
                }
            },
            Day7:{
                daily:{
                    field:"testsDaily7DayMovingAvg",
                    text:"Daily Tests - 7 Day Avg"
                },
                positive:{
                    field:"testspercentpositive7DayMovingAvg",
                    text:"Positivity Rate - 7 Day Avg"
                }
            },
            Day14:{
                daily:{
                    field:"testsDaily14DayMovingAvg",
                    text:"Daily Tests - 14 Day Avg"
                },
                positive:{
                    field:"testspercentpositive14DayMovingAvg",
                    text:"Positivity Rate - 14 Day Avg"
                }
            }
        };


        if (qValues.type == null){
            url=config.apiv2.covidCases;
            qWhere="testsDaily IS NOT NULL";
        }else if(qValues.type==="all"){
            url=config.apiv2.covidCases;
            qWhere="testsDaily IS NOT NULL";
        }else if(qValues.type==="all14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="testsDaily IS NOT NULL";
        }else if(qValues.type==="14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="testsDaily IS NOT NULL AND current14DRecord=1";
        }else{
            url=config.apiv2.covidCases;
            qWhere="testsDaily IS NOT NULL";
        }
            
        if (qValues.trend == null){
            fieldMap=qMap.Day3;
        } else if(qValues.range==="3"){
            fieldMap=qMap.Day3; 
        } else if(qValues.trend==="7"){
            fieldMap=qMap.Day7;
        }else if(qValues.trend==="14"){
            fieldMap=qMap.Day14;
        }else{
            fieldMap=qMap.Day3;
        }


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields",['date','testsPopTested', 'testsDaily', 'testspercentpositive','testsDaily3DayMovingAvg','testspercentpositive3DayMovingAvg','testsDaily7DayMovingAvg','testspercentpositive7DayMovingAvg','testsDaily14DayMovingAvg','testspercentpositive14DayMovingAvg','current14DRecord']);
        formData.append("returnGeometry","false");
        formData.append("orderByFields","date");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            _.forEach(qData.features,function(value,key){
                let validDate = (new Date(value.attributes.date)).getTime();

                let percentValidate = (value.attributes.testsPopTested*100).toFixed(2);
                let cleanTotalValue = (value.attributes.testsDaily).toFixed(0);

                let percentValidateMove = (value.attributes[fieldMap.positive.field]*100).toFixed(2);
                if(percentValidateMove == null){
                    percentValidateMove=0;
                }

                let cleanTotalValueMove = (value.attributes[fieldMap.daily.field]).toFixed(0);
                if(cleanTotalValueMove==null){
                    cleanTotalValueMove=0;
                }


                cleanDate.push(validDate);
                cleanTotalTests.push(cleanTotalValue);
                cleanTestPercent.push(percentValidate);
                dailyMove.push(cleanTotalValueMove);
                positiveMove.push(percentValidateMove);
            });
            // console.log(cleanTotalTests)
            this.setState({
                loading:false,
                error:false,
                series: [ 
                    {
                        name: 'Population Tested %',
                        type: 'line',
                        data: cleanTestPercent
                    },
                     
                    {
                        name: fieldMap.daily.text,
                        type: 'line',
                        data: dailyMove
                    },  
                    {
                        name: 'Daily Tests',
                        type: 'bar',
                        data: cleanTotalTests
                    },
                    
                ],
                options: {
                  ...this.state.options,
                  xaxis: {
                    ...this.state.options.xaxis,
                    categories:cleanDate
                  }
                }
            });

        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                    <div id="chart" style={{height:"92vh",paddingRight:"0",paddingLeft:"0",paddingTop:"0px"}}>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={'100%'} />
                    </div>
            );
        }
    }
  }

export default TestingPopChartV2;